import React from 'react';
import GoogleMapReact from 'google-map-react';
import { Row } from 'antd';
import CustomImage from '../../../../../../../../v2-components/Antd/Image';
import { ENVIROMENT } from '../../../../../../../../v2-config/constants/enviroment.constant';
import './style.scss';

const GoogleMapsMarker = () => (
    <Row className={'google-image-container'}>
        <CustomImage
            src="https://maps.google.com/mapfiles/ms/icons/red-dot.png"
            width={30}
            height={30}
            style={{ position: 'relative', zIndex: 2 }}
        />
    </Row>
);

export default function GoogleMapRoutes(props) {
    const getBoundsZoomLevel = (bounds) => {
        const WORLD_DIM = { height: 256, width: 256 };
        const ZOOM_MAX = 21;

        const latRad = (lat) => {
            const sin = Math.sin(lat * Math.PI / 180);
            const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        const zoom = (mapPx, worldPx, fraction) => {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }

        const ne = bounds.ne;
        const sw = bounds.sw;

        const latFraction = (latRad(ne.lat) - latRad(sw.lat)) / Math.PI;
        const lngDiff = ne.lng - sw.lng;
        const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

        const latZoom = zoom(400, WORLD_DIM.height, latFraction);
        const lngZoom = zoom(400, WORLD_DIM.width, lngFraction);

        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    const calculateBounds = () => {
        const { pharmacyLocation, userLocation } = props;
        
        return {
            ne: {
                lat: Math.max(pharmacyLocation.lat, userLocation.lat),
                lng: Math.max(pharmacyLocation.lng, userLocation.lng)
            },
            sw: {
                lat: Math.min(pharmacyLocation.lat, userLocation.lat),
                lng: Math.min(pharmacyLocation.lng, userLocation.lng)
            }
        };
    }

    const bounds = calculateBounds();
    const center = {
        lat: (bounds.ne.lat + bounds.sw.lat) / 2,
        lng: (bounds.ne.lng + bounds.sw.lng) / 2
    };
    const zoom = getBoundsZoomLevel(bounds); 

    return (
        <Row className="ph-map-withdrawal-pharmacy-routes-container">
            <div className="map-container">
                <GoogleMapReact
                    bootstrapURLKeys={{ key: ENVIROMENT.GOOGLE_MAPS_KEY }}
                    center={center}
                    zoom={zoom}
                >
                    <GoogleMapsMarker
                        lat={props.pharmacyLocation.lat}
                        lng={props.pharmacyLocation.lng}
                    />
                    <GoogleMapsMarker
                        lat={props.userLocation.lat}
                        lng={props.userLocation.lng}
                    />
                </GoogleMapReact>
            </div>
        </Row>
    );
}
